<template>
  <el-card class="box-card mb-50" id="contactDoneMail">
    <el-row>
      <el-col :span="24">
        <div class="mt-0"><span>{{ $t('contacts.mail.done.group_current_input') }}</span></div>
        <div class="form-footer">
          <el-button class="btn-reset" @click="onMyPage">{{ this.role === 3 ? $t('contacts.mail.done.btn') : $t('change_mail.done.btn') }}</el-button>
        </div>
       </el-col>
    </el-row>
  </el-card>
</template>
<script>
  export default {
    props: {
      role: { type: Number, required: true, default: true },
      me: { type: Object, required: true, default: {} },
      pageCheck: { type: String, default: '' },
    },
    data() {
      return {}
    },
    methods: {
      onMyPage() {
        if (this.pageCheck === 'contact') {
          window.location.href = '/my-page'
        } else if (this.role === 3) {
          window.location.href = '/my-page'
        } else {
          window.location.href = `/staff/${this.me.staff_id}`
        }
      },
    },
  }
</script>

<style lang="scss">
  #contactDoneMail {
    padding: 20px;
  }
</style>
